/** Format captain leaderboard sub-line: Top pick Nx · N GWs · N% | — */
export function formatCaptainLeaderboardStats(entry: {
  captain_top_pick_count?: number;
  captain_valid_gws?: number;
  captain_success_pct?: number | null;
}): string {
  const topPick = entry.captain_top_pick_count ?? 0;
  const validGws = entry.captain_valid_gws ?? 0;
  const pct =
    validGws > 0 && entry.captain_success_pct != null ? `${entry.captain_success_pct}%` : '—';

  return `Top pick ${topPick}x · ${validGws} GWs · ${pct}`;
}
